<page-loader *ngIf="!isLoaded"></page-loader>
<div id="page-user-listing" class="page-section" *ngIf="isLoaded">
    <div class="page-section">
        <div class="page-section-header">
            <div class="page-section-buttons">
                <a autoFocus tabindex="0" (click)="createUser()" (keydown.enter)="createUser()"
                    class="trigger-modal invite app-c-btn app-c-btn--primary app-c-btn--curve app-c-btn--with-icon pull-right"><svg-icon icon="plus" alt="plus"></svg-icon><span translate>Create user</span></a>
            </div>
            <div class="page-section-buttons">
                <a tabindex="0" (click)="showInvite('user')" (keypress)="showInvite('user')"
                    class="app-c-btn app-c-btn--primary app-c-btn--curve app-c-btn--with-icon"><svg-icon icon="plus" alt="plus"></svg-icon><span translate>Invite user</span></a>
            </div>
            <h1 translate>userListing.title</h1>
        </div>
        <div class="page-section-content">
            <div class="table-responsive">
                <!--
                    The filter inputs live in this table's header, so it stays
                    mounted while a request is in flight — swapping it for a
                    loader dropped the cursor out of the box mid-typing.
                -->
                <table class="table" [class.is-filtering]="usersLoading">
                    <thead>
                        <tr>
                            <th translate style="width:10%">userListing.headers.0</th>
                            <th translate>userListing.headers.2</th>
                            <th translate>userListing.headers.3</th>
                            <th translate>userListing.headers.4</th>
                            <th translate style="width:11%">userListing.headers.1</th>
                            <th translate style="width:11%">userListing.headers.8</th>
                            <th style="width:9%"></th>
                            <th style="width:5%"></th>
                            <th style="width:5%"></th>
                        </tr>
                        <tr>
                            <th>
                                <!--Name-->
                                <input class="app-c-form-control" type="text" [(ngModel)]="cols[0]" (input)="valueChange(0)" />
                            </th>
                            <th>
                                <!--Email-->
                                <input class="app-c-form-control" type="text" [(ngModel)]="cols[1]" (input)="valueChange(1)" />
                            </th>
                            <th>
                                <!--Organization-->
                                <input class="app-c-form-control" type="text" [(ngModel)]="cols[2]" (input)="valueChange(2)" />
                            </th>
                            <th *ngIf="user.roleId !== 6">
                                <!--User Type-->
                                <select class="app-c-form-control" name="userType" [(ngModel)]="cols[3]" (change)="valueChange(3)">
                                    <option value="">All</option>
                                    <option *ngFor="let role of roles" [value]="role">{{role}}</option>
                                </select>
                            </th>
                            <!--Last login-->
                            <th></th>
                            <!--Status-->
                            <th>
                                <select class="app-c-form-control" name="status" [(ngModel)]="cols[4]" (change)="valueChange(4)">
                                    <option value="">All</option>
                                    <option *ngFor="let status of userStatuses" [value]="status">{{status}}</option>
                                </select>
                            </th>
                            <!--View Details-->
                            <th></th>
                            <!--Disable/Approve-->
                            <th></th>
                            <!--Delete-->
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let user of activeusers" [ngClass]="{'highlighted': user.isPaired}">
                            <td class="strong">
                                <img alt="User avatar" class="rounded" height="20" src="./assets/img/welltrack-boost-circle.png">
                                {{user.fullName}}
                            </td>
                            <td class="strong">{{user.email}}</td>
                            <td class="strong">
                                {{user.organizationStr}}
                            </td>
                            <td class="strong">
                                {{user.userType}}
                            </td>
                            <td class="subtle">{{user.loginOn | date:'MM/dd/yyyy':'UTC'}}</td>
                            <td>
                                {{user.status}}
                            </td>
                            <td>
                                <a tabindex="0" class="pull-right" [routerLink]="['/admin/user', user.id]" translate>userListing.view</a>
                            </td>
                            <td *ngIf="user.status === 'approved'">
                                <a tabindex="0" class="pull-right" (click)="activateUser(user.id, 0)" translate>userListing.disable</a>
                            </td>
                            <td *ngIf="user.status === 'disabled'">
                                <a tabindex="0" class="pull-right" (click)="activateUser(user.id, 1)" translate>userListing.approve</a>
                            </td>
                            <td>
                                <a tabindex="0" class="pull-right" (click)="deleteUser(user.id)" translate>userListing.delete</a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>
